import React from 'react';
import { Button } from './Button';
export function FinalCTA() {
  return <section className="py-8 md:py-12 px-3 md:px-4 bg-gradient-to-b from-dark to-black text-center relative overflow-hidden" data-id="element-66">
      <div className="absolute bottom-0 left-0 w-full h-2 bg-gradient-to-r from-rosa to-terracota" data-id="element-67"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-68">
        <h2 className="text-2xl md:text-3xl font-black text-white uppercase mb-6" data-id="element-69">
          Seguir así también es una decisión
        </h2>

        <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-70">
          <span className="bg-white/5 px-4 py-2 rounded-full text-gray-400 line-through decoration-rosa decoration-2" data-id="element-71">
            Seguir esperando
          </span>
          <span className="bg-white/5 px-4 py-2 rounded-full text-gray-400 line-through decoration-rosa decoration-2" data-id="element-72">
            Seguir dudando
          </span>
          <span className="bg-white/5 px-4 py-2 rounded-full text-gray-400 line-through decoration-rosa decoration-2" data-id="element-73">
            Seguir perdiéndote
          </span>
          <span className="bg-terracota/20 border border-terracota px-4 py-2 rounded-full text-white font-bold" data-id="element-74">
            o empezar a elegirte
          </span>
        </div>

        <div className="bg-black border border-rosa/30 p-6 rounded-2xl mb-8 inline-block" data-id="element-75">
          <h3 className="text-xl font-black text-white uppercase mb-3" data-id="element-76">
            La Mujer que se Elige
          </h3>
          <p className="text-rosa font-bold flex flex-col md:flex-row gap-2 md:gap-4 justify-center" data-id="element-77">
            <span data-id="element-78">Dejar de depender</span>
            <span className="hidden md:inline" data-id="element-79">•</span>
            <span data-id="element-80">Recuperar control</span>
            <span className="hidden md:inline" data-id="element-81">•</span>
            <span data-id="element-82">Volver a vos</span>
          </p>
        </div>

        <Button className="mb-6" data-id="element-83">QUIERO EMPEZAR AHORA</Button>

        <p className="text-lg md:text-xl font-black text-white uppercase tracking-wide mt-8" data-id="element-84">
          No necesitás que alguien te elija
          <br data-id="element-85" />
          <span className="text-terracota" data-id="element-86">necesitás dejar de abandonarte</span>
        </p>
      </div>
    </section>;
}